module.exports = new __parcel__URL__("Sean Kingston - Sally.85aa6e0b.mp3").toString();